import { writable } from 'svelte/store';

export const localStorageWritable = <T>(key: string, initialValue: T) => {
  let parsedValue: T = initialValue;

  try {
    const storedValue = localStorage.getItem(key);
    if (storedValue !== null) {
      parsedValue = JSON.parse(storedValue);
    }
  } catch {
    // unavailable
  }

  const store = writable<T>(parsedValue);
  store.subscribe((value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // unavailable
    }
  });
  return store;
};
